module.exports = "/_next/static/images/6dfd19160770e4524f91039754833ce4-value-proposal.png.webp";